export const myAdvaLogin = {
  domain: "login.advantest.com",
  clientId: "hb6r8l0A8GgS6hpcQjUGjT5MEFy9449S",
  audience: "https://glasswall.advantest.com/",
};

const getApiURL = () => {
  let env = process.env.REACT_APP_AMPLIFY_ENV;
  switch (env) {
    case "prodBackup":
      return `https://api.prodBackup.glasswall.advantest.com`;
    case "prod":
      return "https://api.glasswall.advantest.com";
    case "siemens":
    case "QA":
    case "dev":
    case "staging":
      return `https://api.${env.toLowerCase()}.glasswall.advantest.com`;
    default:
      return "https://api.glasswall.advantest.com";
  }
};

export const baseUrl = getApiURL();
export const spotfireBaseUrl = baseUrl + "/spotfire/wp";
